
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nutrition-packages/[[...slug]]",
      function () {
        return require("private-next-pages/nutrition-packages/[[...slug]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nutrition-packages/[[...slug]]"])
      });
    }
  